import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import React from 'react';
import styles from './Close.module.css';
import { CloseIcon } from './icons';
export default function Close(_a) {
    var kind = _a.kind, onClick = _a.onClick, isHidden = _a.isHidden;
    var cx = classNames.bind(styles);
    var closeClasses = cx('close', "close--".concat(kind), {
        hidden: isHidden,
    });
    return (React.createElement("div", { className: closeClasses, onClick: onClick },
        React.createElement("div", { className: styles.icon },
            React.createElement(CloseIcon, null))));
}
Close.propTypes = {
    kind: PropTypes.oneOf(['negative', 'light']).isRequired,
    onClick: PropTypes.func.isRequired,
    isHidden: PropTypes.bool.isRequired,
};
Close.defaultProps = {
    isHidden: false,
};
